import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import discountSettingService from 'services/discountSetting';

const initialState = {
  loading: false,
  discountSettings: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchDiscountSettings = createAsyncThunk(
  'discountSetting/fetchDiscountSettings',
  (params = {}) => {
    return discountSettingService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  },
);

const discountSettingSlice = createSlice({
  name: 'discountSetting',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDiscountSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchDiscountSettings.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.discountSettings = payload.data;
      state.meta = payload.meta;
      state.params.page = payload.meta.current_page;
      state.params.perPage = payload.meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchDiscountSettings.rejected, (state, action) => {
      state.loading = false;
      state.brands = [];
      state.error = action.error.message;
    });
  },
});

export default discountSettingSlice.reducer;
